import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'gifRenderer'
})
export class GifRendererPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(message: any): SafeHtml {
    console.log('🚀 GifRendererPipe message:', message);
    if (!message || message.customType !== 'GIF') {
      return message?.message || '';
    }

    // Render GIF message as HTML
    const gifUrl = message.data?.gifUrl;
    const gifTitle = message.data?.gifTitle || 'GIF';
    
    if (!gifUrl) {
      return gifTitle;
    }

    const gifHtml = `
      <div class="gif-message">
        <img src="${gifUrl}" 
             alt="${gifTitle}" 
             class="chat-gif" 
             loading="lazy"
             (click)="previewGif('${gifUrl}')">
      </div>
    `;

    return gifHtml;
  }
}
